// Query keys the guild screens share. The table that reads a key and the
// page that invalidates or drops it are two files; the key itself belongs to
// neither.

/**
 * One guild's record with its roster — the card's baseline.
 *
 * Nothing else of the guild hangs off this prefix: the blocks, the chat and
 * its donations live under roots of their own (below, and in GuildChatFeed),
 * so dropping this key drops the card and only the card.
 */
export function guildQueryKey(projectId: string, guildId: string) {
  return ["guild", projectId, guildId] as const;
}

/** The query key the guild page invalidates after a kick. */
export function blocksQueryKey(projectId: string, guildId: string) {
  return ["guild-blocks", projectId, guildId] as const;
}

/**
 * Every page and every search of a project's guild list.
 *
 * This is the prefix the card drops after a disband — the whole list of the
 * project goes, not the one page that happened to be open, because a removed
 * guild shifts every page after its own and the total on all of them.
 */
export function guildsListQueryKey(projectId: string) {
  return ["guilds", projectId] as const;
}

/** One page of the list, for one search term — what the table actually reads. */
export function guildsPageQueryKey(
  projectId: string,
  q: string,
  page: number,
) {
  return [...guildsListQueryKey(projectId), q, page] as const;
}
